export const translations = {
  fi: {
    "common.company": "Yritys",
    "common.businessId": "Yritystunnus",
    "common.office": "Toimipaikka",
    "common.customerNumber": "Asiakasnumero",
    "common.permitNumber": "Lupanumero",
    "common.companyOrPractitioner": "Yritys tai ammatinharjoittaja",
    "common.operatingRight": "Toimintaoikeus",
    "common.person": "Henkilö",
    "common.competencies": "Toimintaoikeudet",
    "common.municipalities": "Kunnat",
    "common.municipality": "Kunta",
    "common.search": "Hae",
    "common.clearForm": "Tyhjennä hakuehdot",
    "common.previous": "Edellinen",
    "common.next": "Seuraava",
    "common.leader": "Vastuuhenkilö",
    "common.results": "Haulla löytyi {results} tulosta",
    "common.searching": "Haetaan tuloksia",
    "common.OperatorRegistryNavigation": "Toiminnanharjoittajarekisteri",
    "common.RefrigerationCompetencyRegistryNavigation": "Kylmäalan pätevyysrekisteri",
    "common.SprayTesterCompetencyRegistryNavigation": "Ruiskuntestaajien pätevyysrekisteri",
    "common.PesticideInstructorTrainerRegistryNavigation": "Kasvinsuojelukoulutuksen ja -tutkinnon järjestäjärekisteri",
    "common.PestControlOperatorRegistryNavigation": "Tuholaistorjunnan toiminnanharjoittajarekisteri",
    "common.PestControlCompetencyRegistryNavigation": "Tuholaistorjunnan pätevyysrekisteri",
    "common.NameStampRegistryNavigation": "Jalometallituotteiden leimarekisteri",
    "common.LocalityStampRegistryNavigation": "Paikkakuntaleimat",
    "common.competencyExplanations.frontPage":
      "Toimintaoikeuksien selitteet löydät {explanationUrl}.",
    "common.competencyExplanations.operator":
      "Toimintaoikeuksien selitteet löydät {explanationUrl}.",
    "common.competencyExplanations.refrigeration":
      "Henkilöpätevyyksien selitteet löydät {explanationUrl}.",
    "common.competencyExplanations.sprayTester":
      "Henkilöpätevyyksien selitteet löydät {explanationUrl}.",
    "common.competencyExplanations.pestControl":
      "Lisätietoja tuholaistorjunnasta {explanationUrl}.",
    "common.competencyAnchorText": "Tukesin www-sivulta",
    "common.booleanYes": "Kyllä",
    "common.booleanNo": "Ei",
    "common.booleanNull": "Kyllä/Ei",
    "common.choose": "Valitse",
    "common.error": "Tapahtui virhe",
    "common.forNow": "Toistaiseksi",
    "common.competency": "Pätevyys",
    "common.validUntil": "Voimassaolo",
    "common.validityEnd": "Voimassaolo päättyy",

    "operatorSearch.header": "Toiminnanharjoittajarekisteri",
    "operatorSearch.inputError": "Syötä yritys, henkilö tai toimintaoikeus.",
    "operatorSearch.chooseCompetencies": "Valitse toimintaoikeudet (enintään 5)",
    "operatorSearch.chooseMunicipalities": "Valitse kunnat (enintään 5)",
    "operatorSearch.personSearchPlaceholder": "Vastuuhenkilön nimi...",
    "operatorSearch.companySearchPlaceholder": "Y-tunnus, toiminimi tai toimipaikka...",

    "operatorSearch.operator": "Toiminnanharjoittaja",
    "operatorSearch.errorUnknown": "Toiminnanharjoittajien haussa tapahtui virhe.",
    "operatorSearch.error1000":
      "Hakuparametrit ovat virheellisiä. Tyhjennä hakuehdot ja yritä uudelleen.",
    "operatorSearch.error1001":
      "Hakuehtosi tuottavat liian suuren määrän hakutuloksia. Rajaa edelleen hakua ja yritä uudelleen.",

    "refrigerationSearch.header": "Kylmäalan pätevyysrekisteri",
    "refrigerationSearch.inputError": "Syötä henkilö, toimintaoikeus tai kunta.",
    "refrigerationSearch.chooseCompetencies": "Valitse toimintaoikeudet",
    "refrigerationSearch.chooseMunicipalities": "Valitse kunnat (enintään 5)",
    "refrigerationSearch.personSearchPlaceholder": "Henkilön nimi...",

    "refrigerationSearch.name": "Nimi",
    "refrigerationSearch.competency": "Toimintaoikeus",
    "refrigerationSearch.municipality": "Kunta",
    "refrigerationSearch.permitNumber": "Lupanumero",
    "refrigerationSearch.validUntil": "Voimassa",
    "refrigerationSearch.searchError": "Henkilöiden haussa tapahtui virhe.",

    "sprayTesterSearch.header": "Ruiskuntestaajien pätevyysrekisteri",
    "sprayTesterSearch.inputError": "Syötä henkilö tai kunta.",
    "sprayTesterSearch.chooseMunicipalities": "Valitse kunnat (enintään 5)",
    "sprayTesterSearch.personSearchPlaceholder": "Henkilön nimi...",

    "sprayTesterSearch.name": "Nimi",
    "sprayTesterSearch.number": "Testaajan numero",
    "sprayTesterSearch.municipality": "Kunta",
    "sprayTesterSearch.phone": "Puhelinnumero",
    "sprayTesterSearch.email": "Sähköposti",
    "sprayTesterSearch.competency": "Kasvihuoneruiskut",
    "sprayTesterSearch.searchError": "Henkilöiden haussa tapahtui virhe.",

    "pesticideInstructorSearch.header": "Kasvinsuojelukouluttajien ja -tutkinnonjärjestäjien rekisteri",
    "pesticideInstructorSearch.inputError": "Valitse pätevyys tai syötä henkilö.",
    "pesticideInstructorSearch.chooseMunicipalities": "Valitse kunnat (enintään 5)",
    "pesticideInstructorSearch.personSearchPlaceholder": "Henkilön nimi...",
    "pesticideInstructorSearch.operationRightsPlaceholder": "Valitse pätevyys...",
    "pesticideInstructorSearch.educationAreaPlaceholder": "Valitse koulutusalat...",
    "pesticideInstructorSearch.KT": "Kasvinsuojelututkinnon järjestäjät",
    "pesticideInstructorSearch.KTT": "Kasvinsuojelukoulutuksen ja tutkinnon järjestäjät",

    "pesticideInstructorSearch.Peltoviljely": "Peltoviljely",
    "pesticideInstructorSearch.PuutarhaviljelyAvomaalla": "Puutarhaviljely avomaalla",
    "pesticideInstructorSearch.Kasvihuoneviljely": "Kasvihuoneviljely",
    "pesticideInstructorSearch.Golfkentat": "Golfkentät",
    "pesticideInstructorSearch.Viheralueet": "Viheralueet",
    "pesticideInstructorSearch.Metsataimitarhat": "Metsätaimitarhat",
    "pesticideInstructorSearch.Metsanhoito": "Metsänhoito",
    "pesticideInstructorSearch.KasvinsuojeluaineidenMyynti": "Kasvinsuojeluaineiden myynti",

    "pesticideInstructorSearch.name": "Nimi",
    "pesticideInstructorSearch.number": "Kouluttajan numero",
    "pesticideInstructorSearch.municipality": "Kunta",
    "pesticideInstructorSearch.phone": "Puhelinnumero",
    "pesticideInstructorSearch.email": "Sähköposti",
    "pesticideInstructorSearch.educationAreas": "Koulutusalat",
    "pesticideInstructorSearch.searchError": "Henkilöiden haussa tapahtui virhe.",

    "pestControlOperatorSearch.header": "Tuholaistorjunnan toiminnanharjoittajien rekisteri",
    "pestControlOperatorSearch.inputError": "Valitse vähintään yksi hakuehto.",
    "pestControlOperatorSearch.chooseMunicipalities": "Valitse kunnat (enintään 5)",
    "pestControlOperatorSearch.personSearchPlaceholder": "Henkilön nimi...",
    "pestControlOperatorSearch.companySearchPlaceholder": "Yrityksen nimi...",
    "pestControlOperatorSearch.officeSearchPlaceholder": "Toimipaikan nimi...",
    "pestControlOperatorSearch.businessIdSearchPlaceholder": "Yrityksen y-tunnus...",
    "pestControlOperatorSearch.BAT_YRTUT": "Tuholaistorjunnan tutkinnon järjestäjä",
    "pestControlOperatorSearch.BAT_YRETU": "Tuholaistorjunnan erityistutkinnon järjestäjä",
    "pestControlOperatorSearch.searchError": "Tuholaistorjunnan toiminnanharjottajien haussa tapahtui virhe.",

    "pestControlCompetencySearch.header": "Tuholaistorjunnan pätevyysrekisteri",
    "pestControlCompetencySearch.inputError": "Syötä haettavan henkilön nimi",
    "pestControlCompetencySearch.personSearchPlaceholder": "Henkilön nimi...",
    "pestControlCompetencySearch.competencyPlaceholder": "Valitse pätevyys...",
    "pestControlCompetencySearch.BAT_TUT": "Tuholaistorjunnan tutkinto",
    "pestControlCompetencySearch.BAT_ETU": "Tuholaistorjunnan erityistutkinto",
    "pestControlCompetencySearch.products": "Valmisteet",
    "pestControlCompetencySearch.number": "Tunniste",
    "pestControlCompetencySearch.searchError": "Tuholaistorjunnan pätevyyksien haussa tapahtui virhe",

    "nameStampSearch.overview.p1": "Tukes pitää rekisteriä Suomessa hyväksytyistä nimi- ja paikkakuntaleimoista. Lisätietoa jalometallituotteiden leimoista löydät <a href='https://tukes.fi/tuotteet-ja-palvelut/jalometallituotteet-korut-ja-kellot/jalometallituotteiden-leimat#d2ebdf5d' target='_blank' rel='noopener noreferrer'>täältä</a>",
    "nameStampSearch.overview.p2": "Nimileimaksi hyväksytään vain isoja kirjaimia. Rekisterissä on myös erikokoisten kirjainten ja kirjainmerkkien yhdistelmiä sekä kuvioita, jotka ovat rekisteröity ennen vuotta 2001. Näiden rekisteröinti on voimassa, jos ne on vahvistettu kolmen vuoden välein. Uusia kuvioleimoja ei myönnetä.",
    "nameStampSearch.overview.p3": "Yli 50 vuotta vanhat ja siitä vanhemmat leimat löytyvät palvelusta <a href='https://www.leimat.fi/fi/' target='_blank' rel='noopener noreferrer'>www.leimat.fi</a>.",
    "nameStampSearch.overview.p4": "<a href='https://tukes.fi/tuotteet-ja-palvelut/jalometallituotteet-korut-ja-kellot/nimileiman-ja-paikkakuntaleiman-haku-tukesista' target='_blank' rel='noopener noreferrer'>Nimileiman ja paikkakuntaleiman haku Tukesista</a>.",
    "nameStampSearch.overview.p5": "Lisätietoja: jalometallituotteet(at)tukes.fi tai puh 029 5052 000.",

    "nameStampSearch.mainHeader": "Nimileimat ja paikkakuntaleimat",
    "nameStampSearch.header": "Nimileimat",
    "nameStampSearch.nameStampType": "Nimileiman tyyppi",
    "nameStampSearch.nameStampCode": "Nimileiman tunnus",
    "nameStampSearch.nameStampTypePlaceholder": "Valitse tyyppi",
    "nameStampSearch.nameStampCodePlaceholder": "ABC tai 123",
    "nameStampSearch.nameStampAll": "Kaikki",
    "nameStampSearch.nameStampLetter": "Kirjaimista koostuvat nimileimat",
    "nameStampSearch.nameStampImage": "Kuviolliset nimileimat",
    "nameStampSearch.chooseMunicipality": "Kunta",
    "nameStampSearch.isInUse": "Käytössä",
    "nameStampSearch.searchError": "Nimileimojen haussa tapahtui virhe.",
    "nameStampSearch.results": "Nimileimahaulla löytyi {results} tulosta",
    "nameStampSearch.companySearchPlaceholder": "Toiminimi",

    "nameStampSearch.code": "Nimileima",
    "nameStampSearch.validityStart": "Voimassaolo alkoi",
    "nameStampSearch.validityEnd": "Voimassaolo päättyy",

    "localityStampSearch.municipalities": "Paikkakunnat",
    "localityStampSearch.header": "Paikkakuntaleimat",
    "localityStampSearch.number": "Numero",
    "localityStampSearch.years": "Käyttövuodet",
    "localityStampSearch.searchError": "Paikkakuntaleimojen haussa tapahtui virhe.",
    "localityStampSearch.results": "Paikkakuntaleimahaulla löytyi {results} tulosta",
    "localityStampSearch.municipality": "Paikkakunta",

    "frontpage.overview": "Täältä löydät Tukesin rekisterissä olevat",
    "frontpage.overview.operator": "toiminnanharjoittajat (asennus- huolto- ja korjaustoiminta)",
    "frontpage.overview.refrigeration": "kylmäalan vastuuhenkilöt ja asentajat",
    "frontpage.overview.sprayTester": "ruiskuntestaajat",
    "frontpage.overview.pestControlOperator": "tuholaistorjunnan toiminnanharjoittajat",
    "frontpage.overview.pestControlCompetency": "tuholaistorjunnan pätevyydet",
    "frontpage.overview.pesticideInstructor": "kasvinsuojelukoulutuksen ja -tutkinnon järjestäjät",
    "frontpage.overview.nameStamp": "jalometallituotteiden nimi- ja paikkakuntaleimat.",
    "frontpage.overview.addendum": "Rekisterin avulla voi tarkistaa, onko toiminnanharjoittajalla säädösten mukainen oikeus tehdä kyseisiä töitä. Toiminnanharjoittaja voi myös tarkistaa omien tietojensa oikeellisuuden.",
    "frontpage.householdExceptions": "Kotitalousvähennyksen saamisen edellytys on, että yritys kuuluu ennakkoperintärekisteriin. Rekisteröinnin voi tarkistaa verotoimistosta tai osoitteesta {ytjUrl}.",

    "footer.header": "Turvallisuus- ja kemikaalivirasto (Tukes)",
    "footer.phonenumber": "029 5052 000 (vaihde)",
    "footer.accessibilityDocument": "Saavutettavuusseloste (pdf)",
  },
  sv: {
    "common.company": "Företag",
    "common.businessId": "FO-nummer",
    "common.office": "Verksamhetsort",
    "common.customerNumber": "Kundnummer",
    "common.permitNumber": "Tillståndsnummer",
    "common.companyOrPractitioner": "Företag eller yrkesutövare",
    "common.person": "Person",
    "common.operatingRight": "Verksamhetsrättighet",
    "common.competencies": "Verksamhetsrättighet",
    "common.municipalities": "Kommuner",
    "common.municipality": "Kommun",
    "common.search": "Sök",
    "common.clearForm": "Rensa sökkriterierna",
    "common.previous": "Föregående",
    "common.next": "Följande",
    "common.leader": "Ansvarsperson",
    "common.results": "Sökningen gav {results} resultat",
    "common.searching": "Sök pågående",
    "common.OperatorRegistryNavigation": "Registret över verksamhetsutövare",
    "common.RefrigerationCompetencyRegistryNavigation": "Behörighetsregistret för kylbranschen",
    "common.SprayTesterCompetencyRegistryNavigation": "Register över auktoriserade spruttestare",
    "common.PesticideInstructorTrainerRegistryNavigation": "Registret av anordnare av växtskyddsutbildningar och -examina",
    "common.PestControlOperatorRegistryNavigation": "Registret av företag som utför yrkesmässig skadedjursbekämpning",
    "common.PestControlCompetencyRegistryNavigation": "Registret över personer som avlagt examen i skadedjursbekämpning",
    "common.NameStampRegistryNavigation": "Stämpelregister över ädelmetallprodukter",
    "common.LocalityStampRegistryNavigation": "Ortsstämplar",
    "common.competencyExplanations.frontPage":
      "Förklaringarna för verksamhetsrättigheter hittar du på {explanationUrl}.",
    "common.competencyExplanations.operator":
      "Se här för beteckningarna för verksamhetsrättigheter: {explanationUrl}.",
    "common.competencyExplanations.refrigeration":
      "Se här för behörighetskoderna: {explanationUrl}.",
    "common.competencyExplanations.sprayTester":
      "Se här för behörighetskoderna: {explanationUrl}.",
    "common.competencyExplanations.pestControl":
      "Mer information om skadedjursbekämpning finns här i {explanationUrl}.",
    "common.competencyAnchorText": "Tukes webbsida",
    "common.booleanYes": "Ja",
    "common.booleanNo": "Nej",
    "common.booleanNull": "Ja/Nej",
    "common.choose": "Välj",
    "common.error": "Ett fel uppstod",
    "common.forNow": "Tills vidare",
    "common.competency": "Verksamhetsrättighet",
    "common.validUntil": "Giltighetstid",
    "common.validityEnd": "Giltigheten utgår",

    "operatorSearch.header": "Registret över verksamhetsutövare",
    "operatorSearch.inputError": "Ange ett företag, en person eller en verksamhetsrättighet.",
    "operatorSearch.chooseCompetencies": "Välj verksamhetsrättigheter (upp till 5)",
    "operatorSearch.chooseMunicipalities": "Välj kommuner (upp till 5)",
    "operatorSearch.personSearchPlaceholder": "Ansvarspersonens namn...",
    "operatorSearch.companySearchPlaceholder": "FO-nummer, firma eller verksamhetsställe...",

    "operatorSearch.operator": "Verksamhetsutövare",
    "operatorSearch.errorUnknown": "Det gick inte att hämta verksamhetsutövarerna.",
    "operatorSearch.error1000":
      "Sökparametrar är felaktiga. Vänligen rensa sökkriterierna och försök igen.",
    "operatorSearch.error1001":
      "Din sökterm ger alltför många sökresultat. Beskär dina sökkriterier och försök igen.",

    "refrigerationSearch.header": "Behörighetsregistret för kylbranschen",
    "refrigerationSearch.inputError": "Ange en person, en verksamhetsrättighet eller en kommun.",
    "refrigerationSearch.chooseCompetencies": "Välj verksamhetsrättigheter",
    "refrigerationSearch.chooseMunicipalities": "Välj kommuner (upp till 5)",
    "refrigerationSearch.personSearchPlaceholder": "Personens namn...",

    "refrigerationSearch.name": "Namn",
    "refrigerationSearch.competency": "Verksamhetsrättighet",
    "refrigerationSearch.municipality": "Kommun",
    "refrigerationSearch.permitNumber": "Tillståndsnummer",
    "refrigerationSearch.searchError": "Det gick inte att hämta personerna.",

    "sprayTesterSearch.header": "Register över auktoriserade spruttestare",
    "sprayTesterSearch.inputError": "Välj verksamhetsrättigheter",
    "sprayTesterSearch.chooseMunicipalities": "Välj kommuner (upp till 5)",
    "sprayTesterSearch.personSearchPlaceholder": "Personens namn...",

    "sprayTesterSearch.name": "Namn",
    "sprayTesterSearch.number": "Nummer",
    "sprayTesterSearch.municipality": "Kommun",
    "sprayTesterSearch.phone": "Telefonnummer",
    "sprayTesterSearch.email": "E-postadress",
    "sprayTesterSearch.competency": "Växthussprutor",
    "sprayTesterSearch.searchError": "Det gick inte att hämta personerna.",

    "pesticideInstructorSearch.name": "Namn",
    "pesticideInstructorSearch.number": "Nummer",
    "pesticideInstructorSearch.municipality": "Kommun",
    "pesticideInstructorSearch.phone": "Telefonnummer",
    "pesticideInstructorSearch.email": "E-postadress",
    "pesticideInstructorSearch.educationAreas": "Utbildningsområde",
    "pesticideInstructorSearch.searchError": "Det gick inte att hämta personerna.",

    "pesticideInstructorSearch.header": "Registret av anordnare av växtskyddsutbildningar och -examina",
    "pesticideInstructorSearch.inputError": "Välj behörighet eller skriv personens namn",
    "pesticideInstructorSearch.chooseMunicipalities": "Välj kommuner (upp till 5)",
    "pesticideInstructorSearch.personSearchPlaceholder": "Personens namn...",
    "pesticideInstructorSearch.operationRightsPlaceholder": "Välj behörighet...",
    "pesticideInstructorSearch.educationAreaPlaceholder": "Välj utbildningsområde...",
    "pesticideInstructorSearch.KT": "Anordnare av växtskyddsexamina",
    "pesticideInstructorSearch.KTT": "Anordnare av växtskyddsutbildning och examina",

    "pesticideInstructorSearch.Peltoviljely": "Åkerbruk",
    "pesticideInstructorSearch.PuutarhaviljelyAvomaalla": "Trädgårdsodling på friland",
    "pesticideInstructorSearch.Kasvihuoneviljely": "Växthusodling",
    "pesticideInstructorSearch.Golfkentat": "Golfbanor",
    "pesticideInstructorSearch.Viheralueet": "Grönområden",
    "pesticideInstructorSearch.Metsataimitarhat": "Skogsplantskolor",
    "pesticideInstructorSearch.Metsanhoito": "Skogsvård",
    "pesticideInstructorSearch.KasvinsuojeluaineidenMyynti": "Försäljning av växtskyddsmedel",

    "pestControlOperatorSearch.header": "Registret av företag som utför yrkesmässig skadedjursbekämpning",
    "pestControlOperatorSearch.inputError": "Välj åtminstone ett alternativ",
    "pestControlOperatorSearch.chooseMunicipalities": "Välj kommuner (upp till 5)",
    "pestControlOperatorSearch.personSearchPlaceholder": "Personens namn...",
    "pestControlOperatorSearch.companySearchPlaceholder": "Företag namn...",
    "pestControlOperatorSearch.officeSearchPlaceholder": "Verksamhetsorts namn",
    "pestControlOperatorSearch.businessIdSearchPlaceholder": "FO-nummer",
    "pestControlOperatorSearch.BAT_YRTUT": "Anordnare av examen för skadedjursbekämpning",
    "pestControlOperatorSearch.BAT_YRETU": "Anordnare av specialexamen för skadedjursbekämpning",
    "pestControlOperatorSearch.searchError": "Det hände ett fel i sökning",

    "pestControlCompetencySearch.header": "Registret över personer som avlagt examen i skadedjursbekämpning",
    "pestControlCompetencySearch.inputError": "Välj behörighet eller skriv personens namn",
    "pestControlCompetencySearch.personSearchPlaceholder": "Personens namn...",
    "pestControlCompetencySearch.competencyPlaceholder": "Välj behörighet...",
    "pestControlCompetencySearch.BAT_TUT": "Examen i skadedjursbekämpning",
    "pestControlCompetencySearch.BAT_ETU": "Specialexamen i skadedjursbekämpning",
    "pestControlCompetencySearch.products": "Produkter",
    "pestControlCompetencySearch.number": "Tagg",
    "pestControlCompetencySearch.searchError": "Det hände ett fel i sökning",

    "nameStampSearch.overview.p1": "Tukes upprätthåller ett register över de namn- och ortsstämplar som godkänts i Finland. Mer information om ädelmetallprodukters stämplar finns <a href='https://tukes.fi/sv/produkter-och-tjanster/adelmetallprodukter-smycken-och-klockor/stamplar-pa-adelmetallprodukter' target='_blank' rel='noopener noreferrer'>här</a>.",
    "nameStampSearch.overview.p2": "Som namnstämpel godkänns endast stora bokstäver. Registret innehåller också kombinationer av bokstäver och skrivtecken i olika storlekar samt figurer som registrerats före 2001. Registreringen för dessa är giltig om den har bekräftats med tre års intervall. Nya figurstämplar beviljas inte.",
    "nameStampSearch.overview.p3": "Stämplar som är 50 år gamla eller äldre finns i tjänsten <a href='http://www.leimat.fi/sv/' target='_blank' rel='noopener noreferrer'>www.leimat.fi/sv/</a>.",
    "nameStampSearch.overview.p4": "<a href='https://tukes.fi/sv/produkter-och-tjanster/adelmetallprodukter-smycken-och-klockor/sa-har-ansoker-du-om-en-namnstampel-och-ortsstampel-hos-tukes' target='_blank' rel='noopener noreferrer'>Ansökan om namnstämpel och ortsstämpel hos Tukes.</a>",
    "nameStampSearch.overview.p5": "Mer information: jalometallituotteet(at)tukes.fi eller tfn 029 5052 000.",

    "nameStampSearch.header": "Namnstämplar",
    "nameStampSearch.nameStampType": "Namnstämpelns typ",
    "nameStampSearch.nameStampCode": "Namnstämpelns beteckning",
    "nameStampSearch.nameStampTypePlaceholder": "Välj typ",
    "nameStampSearch.nameStampCodePlaceholder": "ABC eller 123",
    "nameStampSearch.nameStampAll": "Allt",
    "nameStampSearch.nameStampLetter": "Stämpel som utgörs av bokstäver",
    "nameStampSearch.nameStampImage": "Figurstämpel",
    "nameStampSearch.chooseMunicipality": "Kommun",
    "nameStampSearch.isInUse": "I användning",
    "nameStampSearch.searchError": "Ett fel uppstod i sökningen av namnstämplar",
    "nameStampSearch.results": "{results} resultat hittades vid sökning av namnstämplar",
    "nameStampSearch.companySearchPlaceholder": "Firma",

    "nameStampSearch.code": "Namnstämpel",
    "nameStampSearch.validityStart": "Giltigheten började",
    "nameStampSearch.validityEnd": "Giltigheten utgår",

    "localityStampSearch.municipalities": "Orter",
    "localityStampSearch.header": "Ortsstämplar",
    "localityStampSearch.number": "Nummer",
    "localityStampSearch.years": "Användningsår",
    "localityStampSearch.searchError": "Ett fel uppstod i sökningen av ortstämplar",
    "localityStampSearch.results": "{results} resultat hittades vid sökning av ortstämplar",
    "localityStampSearch.municipality": "Ort",

    "frontpage.overview": "Här finns",
    "frontpage.overview.operator": "Verksamhetsutövare (installations-, service- och reparationsverksamhet)",
    "frontpage.overview.refrigeration": "Ansvarspersoner och montörer (kylbranschen)",
    "frontpage.overview.sprayTester": "Spruttestare",
    "frontpage.overview.pestControlOperator": "Företag som utför yrkesmässig skadedjursbekämpning",
    "frontpage.overview.pestControlCompetency": "Personer som avlagt examen i skadedjursbekämpning",
    "frontpage.overview.pesticideInstructor": "Anordnare av växtskyddsutbildningar och -examina",
    "frontpage.overview.nameStamp": "Ädelmetallprodukters namn- och ortsstämplar som är i Tukes register.",
    "frontpage.overview.addendum": "Med registrets hjälp kan man kontrollera om verksamhetsutövaren enligt lag har rätt att utföra arbetet i fråga. Verksamhetsutövaren kan också kontrollera de egna uppgifternas riktighet.",
    "frontpage.householdExceptions": "Förutsättningen för att erhålla hushållsavdrag är att företaget är infört i förskottsuppbördsregistret. Registreringen kan kontrolleras hos skattebyrån eller på adressen {ytjUrl}.",

    "footer.header": "Säkerhets- och kemikalieverket (Tukes)",
    "footer.phonenumber": "029 5052 000 (växel)",
    "footer.accessibilityDocument": "Tillgänglighetsutlåtande (pdf, 152 kB)",
  },
};


// WEBPACK FOOTER //
// ./src/translations.js